module.exports = __webpack_public_path__ + "img/builds_info@2x.fc5e0b00.jpg";